// extracted by mini-css-extract-plugin
export default {"container":"BgEllipse_container__KHs6N","container__ellipse_1":"BgEllipse_container__ellipse_1__QxqHE","container__ellipse_2":"BgEllipse_container__ellipse_2__rQBpi"};